import React from 'react'
import {Form, ErrorMessage} from 'formik';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const TermsFormComponent = (props) => {
    const toolbarSettings = {
        options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link'],
    }
    const changeEditorStateLKa = (newState) => {
        props.setFieldValue('Text_ka', newState)
    }
    const changeEditorStateLEn = (newState) => {
        props.setFieldValue('Text_en', newState)
    }
    return (
        <div className="container">
            <Form autoComplete="off">
                <div className="form-group">
                    <label className="" htmlFor="Text_ka">
                        {props.langs.adminText} {props.langs.localIn_ka}
                    </label>
                    <div className="border radius-10">
                        <Editor
                            editorState={props.values.Text_ka}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={changeEditorStateLKa}
                            toolbar={toolbarSettings}
                        />
                    </div>
                    <ErrorMessage name="Text_ka" component="label" className="error text-danger pl-25px" />
                </div>
                <div className="form-group">
                    <label className="" htmlFor="Text_en">
                    {props.langs.adminText} {props.langs.localIn_en}
                    </label>
                    <div className="border radius-10">
                        <Editor
                            editorState={props.values.Text_en}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={changeEditorStateLEn}
                            toolbar={toolbarSettings}
                        />
                    </div>
                    <ErrorMessage name="Text_en" component="label" className="error text-danger pl-25px" />
                </div>
                <div className="form-group my-8px">
                    <button type="submit" className={`btn btn-primary`} >
                        {props.langs.adminSave}
                    </button>
                </div>
            </Form>
        </div>
    )
}

export default TermsFormComponent